/**
 * Device detection utilities for responsive behaviour
 */

/**
 * Detects if the user is on a mobile device based on user agent and screen size
 * Mobile devices get full app features, desktop gets read-only view
 */
export const isMobileDevice = (): boolean => {
  // Check user agent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileUA = mobileRegex.test(userAgent);
  
  // Also check for touch capability and screen size
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 768;
  
  // Consider it mobile if it has mobile UA OR (has touch AND small screen)
  return isMobileUA || (hasTouch && isSmallScreen);
};

/**
 * Detects if the device is in landscape orientation
 */
export const isLandscapeOrientation = (): boolean => {
  return window.innerWidth > window.innerHeight;
};

/**
 * Checks if we should show the orientation warning
 * Shows on mobile devices in landscape mode
 */
export const shouldShowOrientationWarning = (): boolean => {
  return isMobileDevice() && isLandscapeOrientation();
};
